import * as API from '../../utils/api'

const FETCH_LOGS = 'FETCH_ACTION_LOGS'

const INITIAL_STATE = {}

// Reducer

export default (state = INITIAL_STATE, action) => {
  if (action.type === `${FETCH_LOGS}_FULFILLED`) {
    let { actionId } = action.meta
    let logs = action.payload.data

    return {
      ...state,
      [actionId]: logs,
    }
  }

  return state
}

// Actions

export const fetchLogs = actionId => ({
  type: FETCH_LOGS,
  payload: API.fetchLogs(actionId),
  meta: { actionId },
})

// Selectors

export const getLogs = actionId => state => {
  let logs = state.logs[actionId]

  return logs
}
